import React from 'react';
import { Grid, List, Box, ListItem, Typography, Paper, makeStyles } from '@material-ui/core';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { loc } from '../../lib/loc';
import { OrderLoc } from '../../loc/order';

import Loader from '../Loader';

const useStyles = makeStyles({
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    specs: {
        fontWeight: 'bold',
        color: '#777777',
        fontSize: '14px',
    },
    data: {
        color: '#3a3a3a',
        fontSize: '14px',
    },
});

const OrderCard = ({ load, data }) => {
    const classes = useStyles();
    return (
        <>
            {load ? (
                <Loader />
            ) : (
                <>
                    {data?.length === 0 ? (
                        <Box py={7} px={4} align="center">
                            <Typography>{loc(OrderLoc.emptyOrderList)}</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={2} justify="center" mb={2}>
                            {data?.map(({ id, beginDate, closeDate, delivery, opportunity, state }) => {
                                return (
                                    <Grid item key={id} sm={6} xs={10}>
                                        <List>
                                            <Paper>
                                                <ListItem className={classes.listItem}>
                                                    <Typography className={classes.specs}>{loc(OrderLoc.table.number)}</Typography>
                                                    <Box align="right">
                                                        <Typography className={classes.data}>{id}</Typography>
                                                    </Box>
                                                </ListItem>
                                                <ListItem className={classes.listItem}>
                                                    <Typography className={classes.specs}>{loc(OrderLoc.table.rentalDates)}</Typography>
                                                    <Typography className={classes.data}>
                                                        {moment(beginDate).isValid() ? moment(beginDate).format('DD.MM.YY') : 'Не указано'}
                                                        <br />
                                                        {moment(closeDate).isValid() ? moment(closeDate).format('DD.MM.YY') : 'Не указано'}
                                                    </Typography>
                                                </ListItem>

                                                <ListItem className={classes.listItem}>
                                                    <Typography className={classes.specs}>{loc(OrderLoc.table.rentEnd)}</Typography>
                                                    <Typography className={classes.data}>
                                                        {moment(closeDate).isValid() ? moment(closeDate).fromNow() : 'Не указано'}
                                                    </Typography>
                                                </ListItem>

                                                <ListItem className={classes.listItem}>
                                                    <Typography className={classes.specs}>{loc(OrderLoc.table.deliveryType)}</Typography>
                                                    <Typography className={classes.data}>{delivery || 'Не указано'}</Typography>
                                                </ListItem>

                                                <ListItem className={classes.listItem}>
                                                    <Typography className={classes.specs}>{loc(OrderLoc.table.status)}</Typography>
                                                    <Typography className={classes.data}>{state || 'Не указано'}</Typography>
                                                </ListItem>

                                                <ListItem className={classes.listItem}>
                                                    <Typography className={classes.specs}>{loc(OrderLoc.table.amount)}</Typography>
                                                    <Typography className={classes.data}>{opportunity} руб.</Typography>
                                                </ListItem>
                                                <Box align="center">
                                                    <Link className="table__link-arrow" to={`/orders/${id}/`}>
                                                        <Typography>Подробнее</Typography>
                                                    </Link>
                                                </Box>
                                            </Paper>
                                        </List>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                </>
            )}
        </>
    );
};

export default OrderCard;
